<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Coupons</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="couponCode" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.couponCode }}</td>
        <td class="text-xs-left">{{ props.item.lifeSpan }}</td>
        <td class="text-xs-left">{{ props.item.lifeUsed }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Coupon Code', align: 'left', value: 'couponCode', sortable: false },
        { text: 'Life Span', align: 'left', value: 'lifeSpan', sortable: false },
        { text: 'Life Used', align: 'left', value: 'lifeUsed', sortable: false }
      ],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  methods: {
    async doInit() {
      await this.queryPromotionCoupons()
    },
    async queryPromotionCoupons() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCoupons
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionCoupon) => {
                const convertPromotionCoupon = {
                  promotion: promotionCoupon.promotion,
                  promotionDesc: promotionCoupon.promotionDesc,
                  couponCode: promotionCoupon.couponCode,
                  lifeSpan: promotionCoupon.lifeSpan,
                  lifeUsed: promotionCoupon.lifeUsed
                }
                this.items.push(convertPromotionCoupon)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
